import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';
import { Routes } from '@angular/router';
import {
  OccupationOfLanePlacementConstructionObjectsSectionComponent
} from './sections/occupation-of-lane-placement-construction-objects-section/occupation-of-lane-placement-construction-objects-section.component';
import {
  PaymentsDataComponentConfig,
  PaymentsDataSectionComponent
} from '../common/payments-data-section/payments-data-section.component';
import {
  OccupationOfLanePlacementConstructionObjectsStatementSectionComponent
} from './sections/occupation-of-lane-placement-construction-objects-statement-section/occupation-of-lane-placement-construction-objects-statement-section.component';

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Inwestor',
  'Dane zajęcia',
  'Prognozowane opłaty',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../inwestor',
  cancelUrl: '../wnioskodawca',
  addObjectNameControl: true,
  addRoadTrafficImpactControl: true
};

export const contractorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  successUrl: '../dane-zajecia',
  cancelUrl: '../dane-wniosku',
  customTitles: {
    sectionTitle: 'Inwestor',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane inwestora',
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie inwestora',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    noDataInfo: 'Brak dodanych inwestorów!'
  }
};

export const paymentsDataSectionConfig: PaymentsDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../dane-zajecia'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../oplaty',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const occupationOfLanePlacementConstructionObjectsRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/inwestor',
    data: contractorDataSectionConfig
  },
  {
    component: OccupationOfLanePlacementConstructionObjectsSectionComponent,
    path: ':appId/dane-zajecia'
  },
  {
    component: PaymentsDataSectionComponent,
    path: ':appId/oplaty',
    data: paymentsDataSectionConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
